"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = exports.createApiClient = void 0;
var client_js_1 = require("./client.js");
Object.defineProperty(exports, "createApiClient", { enumerable: true, get: function () { return client_js_1.createApiClient; } });
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return client_js_1.ApiError; } });
//# sourceMappingURL=index.js.map